<script setup lang="ts">
    import { SidebarGroup, SidebarGroupContent } from '@/components/ui/sidebar';
    import { type NavItem } from '@/types';
    import NavMenu from '@/components/NavMenu.vue';

    interface Props {
        items: NavItem[];
        class?: string;
    }

    defineProps<Props>();
</script>

<template>
    <SidebarGroup :class="`group-data-[collapsible=icon]:p-0 ${$props.class || ''}`">
        <SidebarGroupContent>
            <NavMenu :items="items" />
        </SidebarGroupContent>
    </SidebarGroup>
</template>
